import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=2333edd4&scoped=true&"
import script from "./Set.vue?vue&type=script&lang=ts&"
export * from "./Set.vue?vue&type=script&lang=ts&"
import style0 from "./Set.vue?vue&type=style&index=0&id=2333edd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333edd4",
  null
  
)

export default component.exports